import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useEffect, useState } from "react";

export function DeleteConfirmDialog({ 
  open, 
  onOpenChange, 
  onConfirm, 
  title = "Hapus Data",
  description = "Apakah Anda yakin ingin menghapus data ini? Tindakan ini tidak dapat dibatalkan.",
  itemName = "",
  loading = false,
  showReasonInput = true,
  cascadeChildren = null,
  cascadeLoading = false,
  requireReason = false,
}) {
  const [reason, setReason] = useState("");

  // preventDefault: AlertDialogAction menutup dialog otomatis. Penutupan kini
  // diserahkan ke pemanggil SETELAH hapus berhasil, supaya bila validasi/server
  // menolak, dialog & alasan yang sudah diketik tetap ada.
  const handleConfirm = (e) => {
    e?.preventDefault?.();
    if (requireReason && !reason.trim()) return;
    onConfirm(reason);
  };

  // Alasan dikosongkan setiap kali dialog ditutup, bukan saat tombol diklik.
  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const handleCancel = () => {
    setReason("");
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-600">{title}</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>{description}</p>
            {itemName && (
              <p className="font-semibold text-gray-800 bg-gray-100 p-2 rounded">
                {itemName}
              </p>
            )}
            {cascadeLoading && <p className="text-xs text-slate-500" data-testid="cascade-loading">Memeriksa data turunan...</p>}
            {cascadeChildren && cascadeChildren.length > 0 && (
              <div className="border border-orange-300 bg-orange-50 rounded p-2 text-left" data-testid="cascade-children">
                <p className="text-xs font-semibold text-orange-800 mb-1">Ikut terhapus / berubah ({cascadeChildren.length}):</p>
                <ul className="text-xs text-orange-900 list-disc pl-4 space-y-0.5 max-h-40 overflow-y-auto">
                  {cascadeChildren.map((c, i) => (
                    <li key={i} data-testid={`cascade-child-${i}`}>{c.label}{c.note ? ` — ${c.note}` : ''}</li>
                  ))}
                </ul>
              </div>
            )}
            {cascadeChildren && cascadeChildren.length === 0 && !cascadeLoading && (
              <p className="text-xs text-slate-500" data-testid="cascade-none">Tidak ada data turunan yang terpengaruh.</p>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        
        {showReasonInput && (
          <div className="py-2">
            <Label htmlFor="delete-reason" className="text-sm font-medium">
              Alasan Penghapusan {requireReason ? <span className="text-red-500">(wajib)</span> : '(opsional)'}
            </Label>
            <Input
              id="delete-reason"
              placeholder="Masukkan alasan penghapusan..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="mt-1"
              data-testid="delete-reason-input"
            />
          </div>
        )}

        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel} disabled={loading} data-testid="delete-cancel-btn">
            Batal
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={loading || (requireReason && !reason.trim())}
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
            data-testid="delete-confirm-btn"
          >
            {loading ? "Menghapus..." : "Hapus"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}


